import { configureStore } from "@reduxjs/toolkit";
import languageReducer from "./slices/languageSlice";
import quantityReducer from "./slices/quantitySlice";
import userReducer from "./slices/userSlice";
import addressReducer from "./slices/addressSlice.ts";
// Create the Redux store
const store = configureStore({
  reducer: {
    language: languageReducer,
    quantity: quantityReducer,
    user: userReducer,
    address: addressReducer, // Keep the address reducer
  },
});

export { store };
